import React from 'react';
import styled from 'styled-components';
import {Button, Modal} from 'antd';
import {useOutlet} from 'reconnect.js';
import LoginForm from 'rev.sdk.js/Components/LoginForm';
import NavUrl from 'rev.sdk.js/Utils/NavUrl';
import {getLabel as L} from '../../Locale';
import appConfig from '../../../data.json';
import * as AppActions from '../../AppActions';

function LoginModal(props) {
  const {
    title = '',
    adminTitle = '',
    onBeforeLoginClick = () => true,
    canFacebookLogin = appConfig.canFacebookLogin,
    canLineLogin = appConfig.canLineLogin,
    canGoogleLogin = appConfig.canGoogleLogin,
    canNormalLogin = appConfig.canNormalLogin,
    onForgotPasswordClick = null,
    onRegisterClick = null,
    renderExtra = () => {
      return (
        <div style={{textAlign: 'center', marginBottom: 20}}>
          <p className="text">{L('agree_policy_if_register')}</p>
          <p className="text">
            <Button
              type="link"
              size="small"
              target="_blank"
              href="/privacy-policy">
              {L('privacy_policy')}
            </Button>
            {L('and')}
            <Button
              type="link"
              size="small"
              target="_blank"
              href="/service-policy">
              {L('service_policy')}
            </Button>
          </p>
        </div>
      );
    },
  } = props;
  const [info, setVisible] = useOutlet('login-modal');
  const [actions] = useOutlet('actions');
  const visible = !!info;
  let admin = info && info.admin;

  return (
    <Modal
      title={null}
      footer={null}
      bodyStyle={{padding: 0}}
      width={450}
      visible={visible}
      onOk={() => {
        setVisible(false);
      }}
      onCancel={() => {
        setVisible(false);
      }}
      destroyOnClose={true}>
      <Wrapper>
        <Center>
          <LoginForm
            admin={admin}
            formTitle={title}
            adminFormTitle={adminTitle}
            onBeforeLoginClick={onBeforeLoginClick}
            canFacebookLogin={canFacebookLogin}
            canGoogleLogin={canGoogleLogin}
            canLineLogin={canLineLogin}
            canNormalLogin={canNormalLogin}
            onSucceed={() => {
              if (
                typeof window !== 'undefined' &&
                [
                  '/register/request',
                  '/register/confirm',
                  '/forgot-password/request',
                  '/forgot-password/confirm',
                  '/social-login',
                  '/line/redirect',
                ].includes(window.location.pathname)
              ) {
                AppActions.navigate('/profile');
              }
              setVisible(false);
            }}
            renderExtra={renderExtra}
          />
          {!admin && canNormalLogin && (
            <Container style={{padding: 0}}>
              <div className="text">{L('no_account')}？</div>
              <Button
                className="text"
                type="link"
                size="small"
                onClick={async () => {
                  if (typeof onRegisterClick === 'function') {
                    onRegisterClick();
                    return;
                  }

                  try {
                    actions.setLoading(true);
                    actions.navigate(new NavUrl('/register/request'));
                    await actions.delay(600);
                  } finally {
                    setVisible(false);
                    actions.setLoading(false);
                  }
                }}>
                {L('register_now')}
              </Button>
            </Container>
          )}

          {!admin &&
            canNormalLogin &&
            appConfig.primaryUserType !== 'username' && (
              <Container style={{paddingBottom: 0}}>
                <div className="text">{L('forgot_password')}？</div>
                <Button
                  className="text"
                  type="link"
                  size="small"
                  onClick={async () => {
                    if (typeof onForgotPasswordClick === 'function') {
                      onForgotPasswordClick();
                      return;
                    }

                    try {
                      actions.setLoading(true);
                      actions.navigate(new NavUrl('/forgot-password/request'));
                      await actions.delay(600);
                    } finally {
                      setVisible(false);
                      actions.setLoading(false);
                    }
                  }}>
                  {L('reset')}
                </Button>
              </Container>
            )}
        </Center>
      </Wrapper>
    </Modal>
  );
}

const Wrapper = styled.div`
  font-family: 'Lato', 'Noto Sans TC', sans-serif;
  /* landing 'kepler-3-display-variable' */
  font-weight: 300;
  font-optical-sizing: auto;
  letter-spacing: 1px;
  font-style: normal;
  --text-4-color: #626060;
  --input-border-color: #7b7a7b;

  padding: 40px;
  font-weight: 300;
  color: var(--color-4-text);

  & .text {
  }

  & h2 {
    font-weight: 300;
  }
  & .ant-btn-link {
    font-weight: 300;
  }
`;

const Center = styled.div`
  max-width: 300px;
  width: 100%;
  margin: 0 auto;

  & > h2 {
    margin-bottom: 20px;
    font-size: 25px;
    color: #000000;
    letter-spacing: 3px;
    line-height: 25px;
  }

  & .input-style {
    border: 1px solid var(--input-border-color);
    border-radius: 0;
    padding: 10px 15px;
    height: 45px;
  }

  & .button-style {
    box-shadow: none;
    border-radius: 0;
    padding: 9px;
    width: 100%;
    height: 40px;
    font-weight: 500;
    font-size: 15px;
  }
`;

const Container = styled.div`
  padding: 10px 0px;
  display: flex;
  align-items: center;
`;

export default LoginModal;
